import { DateTime } from 'luxon'

export const getGreeting = () => {
  const hour = DateTime.now().hour
  if (hour < 12) {
    return 'Good morning'
  }
  if (hour < 17) {
    return 'Good afternoon'
  }
  return 'Good evening'
}
